import React from 'react';
import Button from '../Components/Buttons';
import { CustomInput, CustomToggle } from './CustomFormElements';

function ConnectionParameterAttributes({ parameterAttributes, setParameterAttributes, canEdit }) {
  const addParameter = () => {
    setParameterAttributes([
      ...(parameterAttributes || []),
      {
        parameter_name: '',
        parameter_value: '',
        is_masked: false,
      },
    ]);
  };

  const removeParameter = (index) => {
    const next = (parameterAttributes || []).filter((_, i) => i !== index);
    setParameterAttributes(next);
  };

  const updateParameter = (index, field, value) => {
    const next = [...(parameterAttributes || [])];
    next[index] = { ...next[index], [field]: value };
    setParameterAttributes(next);
  };

  const isDisabled = !canEdit;

  return (
    <div className="int-col-3 p-2 border-yes radius-yes full-width-on-sml-scr">
      <h4 className="h4-title">Parameter Overrides</h4>
      <div className="small-font mb-2">
        Define parameters (key/value) that will override tool arguments on requests
      </div>

      {(parameterAttributes || []).map((p, index) => (
        <div key={index} className="attribute-row mb-2 p-2 border-yes radius-yes">
          <div className="input-block d-flex flex-row justify-between">
            <div className="input-description">
              <div className="input-title">Parameter Name</div>
              <div className="small-font">e.g. user_id, locale</div>
            </div>
            <div className="align-wrapper d-flex align-center gap">
              <CustomInput
                id={`parameter-name-${index}`}
                label="Parameter Name"
                placeholder="Enter parameter name"
                type="text"
                value={p.parameter_name || ''}
                onChange={(id, value) => updateParameter(index, 'parameter_name', value)}
                disabled={isDisabled}
              />
              {!isDisabled && (
                <Button variant="danger" size="small" onClick={() => removeParameter(index)}>
                  <i className="fa-solid fa-trash"></i>
                </Button>
              )}
            </div>
          </div>

          <div className="input-block d-flex flex-row justify-between">
            <div className="input-description">
              <div className="input-title">Parameter Value</div>
              <div className="small-font">Value to send (optional)</div>
            </div>
            <div className="align-wrapper d-flex align-center">
              <CustomInput
                id={`parameter-value-${index}`}
                label="Parameter Value"
                placeholder="Enter parameter value"
                type="text"
                value={p.parameter_value || ''}
                onChange={(id, value) => updateParameter(index, 'parameter_value', value)}
                disabled={isDisabled}
              />
            </div>
          </div>

          <div className="input-block d-flex flex-row justify-between">
            <div className="input-description">
              <div className="input-title">Mask in audit logs</div>
              <div className="small-font">Hide this value in audit connections</div>
            </div>
            <div className="align-wrapper d-flex align-center">
              <CustomToggle
                id={`parameter-masked-${index}`}
                label={p.is_masked ? 'Masked' : 'Visible'}
                checked={Boolean(p.is_masked)}
                onChange={(id, value) => updateParameter(index, 'is_masked', value)}
                disabled={isDisabled}
              />
            </div>
          </div>
        </div>
      ))}

      {!isDisabled && (
        <Button variant="secondary" size="medium" onClick={addParameter}>
          <i className="fa-solid fa-plus"></i> Add Parameter
        </Button>
      )}
    </div>
  );
}

export default ConnectionParameterAttributes;
